import {
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_STOCKS_HOME,
} from '@/constants/routes';
import type { SubNavRoute } from '@/constants/routes';

export const discoverRoutes: SubNavRoute[] = [
  {
    to: ROUTE_DISCOVER_INVESTING_IDEAS,
    label: 'Investing Ideas',
  },
  {
    to: ROUTE_STOCKS_HOME,
    label: 'Browse All Stocks',
  },
];
